import { AppConstants } from 'src/app/utilities/app-constants';
const urlPath = AppConstants.URL_DOMAIN_DEV + AppConstants.URL_SUB_PATH;

export const environment = {
  production: true,
  // cognitoUserPoolWebClientId: AppConstants.KEY_USER_POOL_WEB_CLIENT_ID_PROD,
  // urlBatonValidation: AppConstants.URL_AWS_DEV + AppConstants.URL_AWS_VALIDATION_SERVICE_ENDPOINT,
  // urlFetchCognitoToken: urlPath + AppConstants.URL_LOGIN_AUTHENTICATE,
  // // ::: fetch User Details :::
  // urlFetchUserDetails: urlPath + AppConstants.URL_LOGIN_FETCH_USER_DETAILS,

  // ::: fetch cognito token :::
  urlFetchCognitoToken: urlPath + AppConstants.URL_LOGIN_AUTHENTICATE,
  // ::: fetch User Details :::
  urlFetchUserDetails: urlPath + AppConstants.URL_LOGIN_FETCH_USER_DETAILS,
  // :::  :::

  urlBatonValidation:
    AppConstants.URL_AWS_PROD +
    AppConstants.URL_AWS_VALIDATION_SERVICE_ENDPOINT,
  urlChangePassword:
    AppConstants.URL_AWS_PROD + AppConstants.URL_AWS_BATON_CHANGE_PASSWORD,

  urlRedirectToSpAssessments: AppConstants.URL_SP_ASSESSMENTS_PROD,
  urlRedirectToBaton: AppConstants.URL_PROD_BATON_REDIRECTION,
  urlRedirectToBatonDashboard:
    AppConstants.URL_PROD_BATON_DASHBOARD_REDIRECTION,

  urlRedirectionBatonConfig: AppConstants.URL_PROD_BATON_CONFIG_REDIRECTION,

  urlBatonGetFeatures: AppConstants.URL_BATON_GET_FEATURES_PROD,


  urlAppsyncGraphQl: AppConstants.URL_PROD_APPSYNC_GRAPHQL_ENDPOINT,
  urlActivity:AppConstants.URL_PROD_PLAYCLAY_ACTIVITY,

  paramAppsynRegion: AppConstants.PARAM_PROD_APPSYNC_REGION,
  paramAppsyncApiKey: AppConstants.PARAM_PROD_APPSYNC_API_KEY,
  paramAppsynUserPoolId: AppConstants.PARAM_PROD_APPSYNC_USERPOOL_ID,
  paramAppsynUserPoolWebClientId:
    AppConstants.PARAM_PROD_APPSYNC_USERPOOL_WEBCLIENT_ID,

    urlS3BucketForMetrics: AppConstants.PARAM_PROD_S3_BUCKET_FOLIO,
    awsRegion: AppConstants.AWS_REGION_PROD,
    awsPoolId: AppConstants.AWS_IDENTITYPOOL_ID_PROD,
    lambdaGetFeatures: AppConstants.LAMBDA_NAME_BATON_GET_FEATURES_PROD,
    lambdaQSDashboardURL: AppConstants.LAMBDA_NAME_FOLIO_GET_QSDASHBOARDURL_PROD,
    aws_accountId: AppConstants.AWS_ACCOUNTID_PROD,
    qs_userroleARN: AppConstants.QSUSERACCESS_ROLEARN_PROD,
    qs_dashboardId: AppConstants.QSDASHBOARD_ID_PROD
};
